import { http } from '@/core/helpers/http.helper';
export class ActionService {
   async sendActionMail(userId: number) {
      return await http.post(`/users/${userId}/send-action-mail`);
   }
}
